import { render, staticRenderFns } from "./Physiotherapist.vue?vue&type=template&id=52117102&scoped=true"
import script from "./Physiotherapist.vue?vue&type=script&lang=js"
export * from "./Physiotherapist.vue?vue&type=script&lang=js"
import style0 from "./Physiotherapist.vue?vue&type=style&index=0&id=52117102&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52117102",
  null
  
)

export default component.exports